import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AccountControls extends ThemeComponent {
    @Ref({required: false}) trigger!: HTMLButtonElement;
    @Ref({required: false}) triggerText!: HTMLButtonElement;
    @Ref() control!: HTMLElement[];

    init() {
        this.handleText();
        this.setHeight();
        this.setEventListeners();
    }

    setEventListeners() {
        if (!this.trigger) { return; }
        this.$listen(this.trigger, 'click', () => {
            this.trigger.classList.toggle('is-active');
            this.trigger.parentElement?.classList.toggle('is-active');
            document.body.classList.toggle('drawer-open');
        });
    }

    setHeight() {
        const header = document.querySelector('site-header') as HTMLElement;
        const heightRow = header?.offsetHeight;
        const triggerHeight = this.trigger.offsetHeight;
        const controls = this.trigger.nextElementSibling as HTMLElement;

        controls.style.maxHeight = `calc(100vh - (${~~heightRow + ~~triggerHeight}px))`;
    }

    handleText() {
        if (!this.triggerText) { return; }
        for (const control of this.control) {
            if (control.classList.contains('active')) {
                const text = control.innerText.replace(/(\r\n|\n|\r)/gm, '');
                this.triggerText.innerText = text;
            }
        }
    }

}
